import { render } from "./DebtConnect.vue?vue&type=template&id=b7638c70&scoped=true"
import script from "./DebtConnect.vue?vue&type=script&lang=js"
export * from "./DebtConnect.vue?vue&type=script&lang=js"

import "./DebtConnect.vue?vue&type=style&index=0&id=b7638c70&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/spinwheel-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7638c70"]])

export default __exports__